module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icn-campany-greeting-40d102d9049b320a3d7103376e8c38d5.svg";